import React from 'react';
const millingCards = [{
  title: '3 & 4-Axis Vertical Machining Centers',
  href: '/Spinner3_4AxisMilling.html',
  imageSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/3%20or%204-Axis%20Vertical%20Mach%20Center.png800x800.png',
  imageAlt: '3 or 4-Axis Vertical Machining Center'
}, {
  title: '5-Axis Vertical Machining Centers',
  href: '/Spinner5AxisMilling.html',
  imageSrc: 'https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/5-Axis%20Vertical%20Mach%20Center.png800x800.png',
  imageAlt: '5-Axis Vertical Machining Center'
}];
export function MillingSection() {
  return <div className="mb-20" data-id="element-3838">
      <h2 className="text-3xl font-bold text-navy mb-2" data-id="element-3839">Milling</h2>
      <p className="text-gray-600 mb-8 text-lg" data-id="element-3840">
        Machining Centers for 3, 4, and 5-Axis...
      </p>
      <div className="grid sm:grid-cols-2 gap-8" data-id="element-3841">
        {millingCards.map(card => <a key={card.title} href={card.href} className="group block bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-[#002d4d] hover:shadow-xl transition-all duration-300" data-id="element-3842">
            <div className="p-6 flex items-center justify-center bg-gray-50" data-id="element-3843">
              <img src={card.imageSrc} alt={card.imageAlt} className="max-w-full h-auto max-h-[280px] object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-3844" />
            </div>
            <div className="p-5 bg-white border-t border-gray-100" data-id="element-3845">
              <h3 className="text-lg font-bold text-navy text-center group-hover:text-[#002d4d] transition-colors" data-id="element-3846">
                {card.title}
              </h3>
            </div>
          </a>)}
      </div>
    </div>;
}